import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  getCPAppointmentList,
  cpAppointmentStatusUpdate,
} from "../../reduxStore/action/userAppointmentAction";
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import { handleListResponse } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import moment from "moment";
import Button from "component/Button";

const CpAppointmentList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cpAppointmentList, setCpAppointmentList] = useState([]);
  const [selectedAppointment, setSelectedAppointment] = useState(null); // Selected appointment for modal
  const [statusToUpdate, setStatusToUpdate] = useState(null); // To track the status to update (Cancel/Done)
  const [comment, setComment] = useState(""); // Comment box for modal // State to manage the selected appointment for detail view
  const cpAppointmentSelector = useSelector((state) => state?.cpAppointment);
  const { view, isAdmin } = usePermission({
    view: "appointment_with_cp",
  });

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  useEffect(() => {
    dispatch(getCPAppointmentList({ appoiment: 2 }));
  }, [dispatch]);

  useEffect(() => {
    const { response = null, create = false } = cpAppointmentSelector;
    if (response && response?.status === 200) {
      if (!create && response.data?.length > 0) {
        setCpAppointmentList(
          handleListResponse(response?.data) ? response?.data : []
        );
      }
    } else {
      setCpAppointmentList([]);
    }
  }, [cpAppointmentSelector]);

 

  const handleViewDetails = (item) => {
    // Navigate to the Appointment Details page and pass the selected appointment data via state
    navigate("/appointment-details", { state: { appointment: item } });
  };

  const handleStatusChange = (appointment, status) => {
    setSelectedAppointment(appointment);
    setStatusToUpdate(status); // 1 - Cancel, 2 - Done (you can add more statuses if needed)
  };

  // Handle updating appointment status
  const handleUpdateStatus = async () => {
    if (selectedAppointment) {
      const updatedStatus = {
        appointment_id: selectedAppointment._id,
        appointment_status: statusToUpdate, // Make sure 'statusToUpdate' is properly set
        remark: comment,
      };

      // Dispatch the status update action
      await dispatch(cpAppointmentStatusUpdate(updatedStatus)); // Ensure this completes before fetching appointments

      // After the status update, fetch the appointment list again
      await dispatch(getCPAppointmentList({ appoiment: 2 }));

      // Reset the comment and close the modal
      setComment(""); // Reset comment
      setSelectedAppointment(null); // Close the modal
    }
  };

  const handleEdit = (item) => {
    let appointment_id = item ? "?appointment_id=" + item : "";
    navigatpage("/add_appointment_with_cp" + appointment_id);
  };

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.apptWithCp}
        titleactive={strings.appointmentListCP}
      />
      <div className="container-fluid">
        {!isAdmin && view && (
          <div className="row pt-3">
            <div className="col-md-6">
              <div className="form-group">
                <button
                  className="btn btn-color"
                  type="button"
                  onClick={() => navigatpage("/add_appointment_with_cp")}
                >
                  {strings.addAppointment}
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="card">
              <div className="card-header">
                <h5>{strings.appointmentList}</h5>
              </div>
              <div className="table-responsive">
                <table className="table table-border-horizontal">
                  <thead className="text-center">
                    <tr>
                      <th scope="col">{strings.date}</th>
                      <th scope="col">{strings.time}</th>
                      <th scope="col">Appointment Type</th>
                      <th scope="col">Appointment With</th>
                      <th scope="col">{strings.property_name}</th>
                      <th scope="col">{strings.status}</th>
                      <th scope="col">{strings.action}</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {cpAppointmentList?.length > 0 ? (
                      cpAppointmentList.map((item, index) => {
                        return (
                          <tr key={item._id}>
                            <td style={{ inlineSize: "130px" }}>
                              {item?.appointment_date
                                ? moment(item?.appointment_date).format(
                                    "DD-MM-yyyy"
                                  )
                                : strings.notavailable}
                            </td>
                            <td>{item.appointment_time}</td>
                            <td>{item.appointment_type_title}</td>
                            <td>{item.receiver_name}</td>
                            <td>{item.property_id ?  item.property_title : "N/A"}</td>
                            <td
                              style={{
                                color:
                                  item.appointment_status === 3
                                    ? "green"
                                    : "red", // Green for Complete, Red for other statuses
                              }}
                            >
                              {item.appointment_status === 1 && "Pending"}
                              {item.appointment_status === 2 && "Confirm"}
                              {item.appointment_status === 3 && "Complete"}
                              {item.appointment_status === 4 &&
                                "Appointment Cancel"}
                            </td>
                            <td className="p-2">
                              {view && (
                                <>
                                  {/* Show Cancel and Done buttons only if the status is not 3 (Complete) or 4 (Cancelled) */}
                                  {item.appointment_status !== 3 &&
                                    item.appointment_status !== 4 && (
                                      <>
                                        <Button
                                          label="Edit"
                                          onClick={() => handleEdit(item._id)} // Status 3 - Done
                                          className="btn-sm mr-2" // Small button and margin-right (gap)
                                          style={{
                                            color: "violet",
                                            borderColor: "violet",
                                             backgroundColor:"white"
                                          }}
                                        />
                                        <Button
                                          label="Cancel"
                                          onClick={() =>
                                            handleStatusChange(item, 4)
                                          } // Status 4 - Cancel
                                          className="btn-sm mr-2" // Small button and margin-right (gap)
                                          style={{
                                            color: "lightblue",
                                            borderColor: "lightblue",
                                             backgroundColor:"white"
                                          }}
                                        />
                                        <Button
                                          label="Done"
                                          onClick={() =>
                                            handleStatusChange(item, 3)
                                          } // Status 3 - Done
                                          className="btn-sm" // Small button
                                          style={{
                                            color: "green",
                                            borderColor: "green",
                                            backgroundColor:"white"
                                          }}
                                        />
                                      </>
                                    )}
                                  <i
                                    className="fa fa-eye theme-fa-icon p-2"
                                    aria-hidden="true"
                                    title={"View Appointment"}
                                    onClick={() => handleViewDetails(item)}
                                  ></i>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr />
                    )}
                  </tbody>
                </table>
                <TableDataNotFound data={cpAppointmentList} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Conditional rendering for the Appointment Details Component */}
      {selectedAppointment && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)", // Semi-transparent black background
            backdropFilter: "blur(8px)", // Apply blur effect
            zIndex: 999, // Ensure it appears above other elements
            display: "flex",
            justifyContent: "center",
            alignItems: "center", // Center the modal vertically and horizontally
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "500px",
              width: "100%",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              animation: "fadeInUp 0.4s ease-out", // Smooth fade-in animation
            }}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5>Update Status</h5>
                <button
                  style={{ fontSize: "20px", cursor: "pointer" }}
                  onClick={() => setSelectedAppointment(null)}
                >
                  &times;
                </button>
              </div>
              <div style={{ marginTop: "10px" }}>
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Add a comment"
                  rows="4"
                  className="form-control"
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    resize: "none", // Prevent resizing
                  }}
                />
              </div>
              <div
                style={{
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    padding: "8px 15px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedAppointment(null)}
                >
                  Cancel
                </button>
                <button
                  style={{
                    backgroundColor: "#007bff",
                    color: "#fff",
                    padding: "8px 15px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleUpdateStatus(
                      selectedAppointment.appointment_status === 1 ? 2 : 3
                    )
                  } // Example status change
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CpAppointmentList;
